/**
 * Check store for timestamped persisted value by module and key with maxAge [msec].
 */
export const getPersistedValue = function (storeModule, key, maxAge) {
    if (!process.client) {
        return;
    }

    // check the store for value
    const value = storeModule[key];
    if (!value || Object.keys(value).length === 0) {
        // console.log("no value found for", key);
        return null;
    }

    const timestamp = storeModule['timestamps'][key];
    // no timestamp, return value
    if (!timestamp) {
        // console.log("no timestamp but value ok", key);
        return value;
    }

    // timestamp found, check age
    const age = new Date() - new Date(timestamp);
    if (age < maxAge) {
        // console.log("timestamped persisted value ok", key);
        return value;
    }

    // console.log("timestamped persisted value expired", key);
};
